import React from "react";
import { HomeAdmintrador } from "../../../components/Admin/Home";


export const InicioAdministrador = () => {
    return(
        <>
       <HomeAdmintrador/>
        </>
    )
}